import { ProductsEffects as Effects } from './products.effects';

export const ProductsEffects = [Effects];
